import React from "react";
import { useState } from "react";
import useGameStore from "../store/gameStore";
import CrownIcon from "../assets/crown.svg";

function NewHighScore() {
  const [name, setName] = useState("");
  const score = useGameStore((s) => s.newHighScore);
  const submitHighScore = useGameStore((s) => s.submitHighScore);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const trimmed = name.trim();
    if (!trimmed) return;
    submitHighScore(trimmed);
  };

  return (
    <div
      style={{
        zIndex: "7",
        width: "320px",
        height: "200px",
        background:
          "linear-gradient(90deg, rgba(255,57,57,1) 0%, rgba(255,121,24,1) 19%, rgba(255,209,48,1) 40%, rgba(138,222,99,1) 59%, rgba(85,143,255,1) 81%, rgba(150,102,252,1) 100%)",
        color: "white",
        position: "absolute",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        fontFamily: "Jua, sans-serif",
        borderRadius: "35px",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        boxShadow:
          "inset 0 0 0 #ff3939, 0 0 40px #ff7918, -10px 0 80px #8ade63,10px 0 80px #9666fc",
      }}
    >
      <div
        style={{
          margin: "auto",
          height: "95%",
          width: "96%",
          backgroundColor: "#2F2F2F",
          borderRadius: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <img
          src={CrownIcon}
          alt="crown"
          style={{ height: "30px" }}
        />
        <h2>new leaderboard record!</h2>
        <span style={{ color: "lightgray" }}>SCORE: {score}</span>
        <form
          onSubmit={handleOnSubmit}
          style={{
            height: "60px",
            width: "72%",
            fontSize: "30px",
            textAlign: "center",
            padding: "7px",
            background:
              "linear-gradient(90deg, rgba(255,57,57,1) 0%, rgba(255,121,24,1) 19%, rgba(255,209,48,1) 40%, rgba(138,222,99,1) 59%, rgba(85,143,255,1) 81%, rgba(150,102,252,1) 100%)",
            borderRadius: "25px",
            marginTop: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <input
            type="text"
            placeholder="enter your name"
            maxLength={12}
            onChange={(e) => setName(e.target.value)}
            style={{
              border: "none",
              outline: "2px solid white",
              borderRadius: "17px",
              padding: "10px",
              fontFamily: "Jua, sans-serif",
              textAlign: "center",
              fontSize: "20px",
              width: "100%",
              height: "100%",
            }}
          />
        </form>
      </div>
    </div>
  );
}

export default NewHighScore;
